import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import CreateTicketLinkMutation from '../../../../../mutations/ticketing/tickets/createTicketLinkMutation';

export interface CreateTicketLinkInput {
	ticketId: string;
	linkType: 'related' | 'child' | 'project';
	targetTicketId?: string | null;
	targetProjectId?: string | null;
}

export function useCreateTicketLink() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(input: CreateTicketLinkInput) {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				CreateTicketLinkMutation,
				input,
				response => {
					setLoading(false);
					resolve(response.createTicketLink.ticketLink);
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
